module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_WFP_Book_Title"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "id": "TitleText_eBook",
      "src": "TitleText_eBook.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_By_Line"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "id": "NameText_eBook",
      "src": "NameText_eBook.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_Center",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Digital Edition – 2017")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_Center"
  }, [_c('span', [_vm._v("WordFire Press"), _c('br'), _vm._v("wordfirepress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_Center"
  }, [_c('span', [_vm._v("ISBN: "), _c('span', {
    staticClass: "C_DefaultParagraphFont__And__Black_Text"
  }, [_vm._v("978-1-61475-457-2")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_Center"
  }, [_c('span', [_vm._v("Copyright © 1999 by Robert Asprin")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_left"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any electronic or mechanical means, including photocopying, recording or by any information storage and retrieval system, without the express written permission of the copyright holder, except where permitted by law. This novel is a work of fiction. Names, characters, places and incidents are either the product of the author’s imagination, or, if real, used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_left"
  }, [_vm._v("This book is licensed for your personal enjoyment only. This ebook may not be re-sold or given away to other people. If you would like to share this book with another person, please purchase an additional copy for each recipient. Thank you for respecting the hard work of this author.")]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_Center"
  }, [_c('span', [_vm._v("Cover design by Janet McDonald")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_Center"
  }, [_c('span', [_vm._v("Cover artwork images by Jeff Herndon")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_Center"
  }, [_c('span', [_vm._v("Kevin J. Anderson, Art Director")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_Center"
  }, [_c('span', [_vm._v("Book Design by RuneWright, LLC"), _c('br'), _vm._v("www.RuneWright.com")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_Center"
  }, [_c('span', [_vm._v("Kevin J. Anderson & Rebecca Moesta, Publishers")])]), _vm._v(" "), _c('p', {
    staticClass: "P_WFP_Copyright_Center"
  }, [_c('span', [_vm._v("Published by"), _c('br'), _vm._v("WordFire Press, an imprint of"), _c('br'), _vm._v("WordFire, Inc."), _c('br'), _vm._v("PO Box 1840"), _c('br'), _vm._v("Monument, CO 80132")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 66
// module chunks = 0